import { ListChecks } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export function RequirementList({
  title,
  items,
  className,
}: {
  title: string
  items: string[]
  className?: string
}) {
  if (items.length === 0) {
    return null
  }

  return (
    <section className={cn('rounded-lg border border-border bg-card p-4 shadow-sm', className)} aria-label={title}>
      <div className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <ListChecks className="size-4 shrink-0" aria-hidden />
        <h2 className="text-sm font-semibold">{title}</h2>
      </div>
      <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
        {items.map((item) => (
          <li key={item} className="flex gap-2">
            <span className="mt-2 size-1.5 shrink-0 rounded-full bg-primary" aria-hidden />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}
